// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const feedbackTypes = [
   'Please choose one of the following',
   'General Feedback',
   'Didn\'t find what I was looking for',
   'Report a problem or bug',
   'Request a new feature',
   'Link didn\'t work as expected'
]

const feedbackUserRoles = [
   'Please choose one of the following',
   'Undergraduate Student',
   'Graduate Student',
   'Researcher',
   'Faculty',
   'Alumni',
   'Other'
]
angular.module('summonApp.constants')
   .constant('$feedbackTypes', feedbackTypes)
   .constant('$feedbackUserRoles', feedbackUserRoles)
